import React from 'react'
import { trackGuiInteracted } from 'src/dataLayer/remoteData/babbelEventStream'
import { useRouteParamsContext } from 'src/viewLayer/components/contexts/RouteParamsContext'
import { Button } from 'src/viewLayer/components/DesignSystem'

export default ({
  buttonIcon,
  children,
  color = 'primary',
  dataTestid,
  disabled,
  fullWidth = true,
  href,
  id,
  inProgress,
  minWidth = 152,
  onClick = () => {},
  title,
  trackingId,
}) => {
  const { learnLanguageCode, locale } = useRouteParamsContext()

  const trackClick = () => {
    if (inProgress || !disabled) {
      trackGuiInteracted({
        guiElementName: trackingId,
        learnLanguageCode,
        locale,
      })
    }
  }

  const handleClick = (event) => {
    trackClick()
    onClick(event)
  }

  return (
    <Button
      as={href ? 'a' : 'button'}
      color={buttonIcon ? 'secondary' : color}
      data-testid={dataTestid}
      disabled={disabled}
      fullWidth={fullWidth}
      href={href}
      icon={buttonIcon}
      id={id}
      // The design system mirrors `loading` into aria-disabled, so a plain `false` would render
      // aria-disabled="false" and contradict a natively disabled button. Omit it when idle.
      loading={inProgress || undefined}
      minWidth={minWidth}
      onClick={(event) => handleClick(event)}
      title={title}
    >
      {children}
    </Button>
  )
}
